// OWNER: platform module (offline area). Clears everything the offline feature keeps on the device
// (ADR 0004: "cleared on sign-out"). Called by useSignOut (src/hooks/useSignOut.ts).
// Cache Storage holds only the app shell (no API data), so it is left in place for a fast next start.
import { offlineQueue, type Outbox } from './outbox';

export async function clearOfflineData(outbox: Outbox = offlineQueue): Promise<void> {
  try {
    await outbox.clearAll();
  } catch {
    // Never block sign-out.
  }
}
